import { useTranslation } from '@supply-mover-2-0/web-ui';
import type { ReactElement } from 'react';
import type { StockQuantityLineModel } from '../lib/stockQuantityLine';

/**
 * PD-16750 — a product's quantity line ("37 in stock", "11-50 in stock",
 * "Medium stock"), shared by the catalog cards and the product page so both
 * word every stock display the same way. See resolveStockQuantityLine.
 */
export function StockQuantityText({
	line,
}: {
	line: StockQuantityLineModel;
}): ReactElement {
	const { t } = useTranslation();

	switch (line.kind) {
		case 'inStock':
			return (
				<>
					{t(line.value)} {t('in stock')}
				</>
			);
		case 'level':
			return (
				<>
					{t(line.value)} {t('stock')}
				</>
			);
		case 'label':
			return <>{t(line.value)}</>;
	}
}
